import { HiClipboardCheck, HiIdentification, HiPlus, HiUser, HiViewGrid, HiViewList, HiQuestionMarkCircle, HiSearchCircle, HiClipboardCopy } from "react-icons/hi";

export const dashboardItems = [
  {
    to: "dashboard",
    name: "Dashboard",
    icon: <HiViewGrid />,
  },
];

export const systemItems = [
  {
    to: "create-system",
    name: "Create system",
    icon: <HiPlus />,
  },
  {
    to: "system-list",
    name: "System list",
    icon: <HiViewList />,
  },
];

export const organItems = [
  {
    to: "create-organ",
    name: "Create organ",
    icon: <HiPlus />,
  },
  {
    to: "organ-list",
    name: "Organ list",
    icon: <HiViewList />,
  },
];

export const diagnosisItems = [
  {
    to: "create-diagnosis",
    name: "Create diagnosis",
    icon: <HiPlus />,
  },
  {
    to: "diagnosis-list",
    name: "Diagnosis list",
    icon: <HiViewList />,
  },
];

export const questionItems = [
  {
    to: "create-question",
    name: "Create question",
    icon: <HiPlus />,
  },
  {
    to: "question-list",
    name: "Question list",
    icon: <HiViewList />,
  },
  {
    to: "assign-reviewer",
    name: "Assign reviewer",
    icon: <HiIdentification />,
  },
  {
    to: "contributor-answer",
    name: "Contributor answer",
    icon: <HiClipboardCheck />,
  },
  {
    to: "contributor-questions",
    name: "Contributor question",
    icon: <HiClipboardCopy />,
  },
];

export const accessItems = [
  {
    to: "create-free-user",
    name: "Create New User",
    icon: <HiPlus />,
  },
  {
    to: "free-user-list",
    name: "User List",
    icon: <HiViewList />,
  },
];

export const userItems = [
  {
    to: "all-users",
    name: "All Users",
    icon: <HiViewList />,
  },
  {
    to: "all-contributors",
    name: "All Contributors",
    icon: <HiUser />,
  },
];

export const reportItems = [
  {
    to: "all-users",
    name: "All Users",
    icon: <HiViewList />,
  },
  {
    to: "all-contributors",
    name: "All Contributors",
    icon: <HiUser />,
  },
];

export const searchItems = [
  {
    to: "search",
    name: "Search",
    icon: <HiSearchCircle />,
  },
];

export const helpItems = [
  {
    to: "help",
    name: "Help",
    icon: <HiQuestionMarkCircle />,
  },
];

export const caseStudyModule = [
  {
    to: "create-case-study",
    name: "Create Case Study",
    icon: <HiPlus />,
  },
  {
    to: "case-study-list",
    name: "Case Study List",
    icon: <HiViewList />,
  },
];
